import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_ALERT: GlameraIconDefinition = {
  name: 'circle-alert',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-alert-ring" cx="12" cy="12" r="10"></circle>
    <g class="glm-circle-alert-mark">
      <line x1="12" x2="12" y1="8" y2="12"></line>
      <line x1="12" x2="12.01" y1="16" y2="16"></line>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-alert-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-alert.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleAlertIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_ALERT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
